import React, { useEffect } from "react";
import { TbBrandGoogle } from "react-icons/tb";
import { useAuthHandler } from "../../../hooks";
import { yupResolver } from "@hookform/resolvers/yup";
import { REGISTER_VALIDATION_SCHEMA } from "../../../utils/schema/password_schema";
import { useForm } from "react-hook-form";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Link } from "react-router-dom";
import { successPopup } from "../../../helpers";
import Swal from "sweetalert2";

export const RegisterForm = ({ setIsModalOpen, setIsRegister }) => {
  const { loginWithGoogle, register: formSubmit } = useAuthHandler();
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(REGISTER_VALIDATION_SCHEMA),
  });

  // Use useEffect to watch for errors
  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      // Get the first error message
      const firstError = Object.values(errors)[0].message;

      // Show the error using SweetAlert2
      Swal.fire({
        icon: "error",
        text: firstError,
      });
    }
  }, [errors]); // Trigger useEffect when `errors` changes

  const [showPassword, setShowPassword] = React.useState(false);
  const [showPassword1, setShowPassword1] = React.useState(false);

  const togglePasswordVisibility = () => setShowPassword(!showPassword);
  const togglePasswordVisibility1 = () => setShowPassword1(!showPassword1);

  const onSubmit = async (data) => {
    try {
      await formSubmit(data).then((response) => {
        console.log("response", response);
        if (response?.data?.status) {
          reset();
          setIsModalOpen(false);
          setIsRegister(false);
          successPopup(
            "",
            "We have sent you an email. Please verify your email to activate your account. This may take a few minutes. Be sure to check your inbox, spam, and promotions folders."
          );
        } else {
          // errorPopup('', response?.data?.message);
        }
      });
    } catch (ex) {
      console.log(ex);
      // errorPopup('', ex.response?.data?.message)
    }
  };
  return (
    <div className="z-50 bg-white login-column">
      <div className="m-0 main-register-holder tabs-act">
        <div className="main-register fl-wrap">
          <ul className="flex items-center justify-between tabs-menu fl-wrap no-list-style">
            <h4 className="text-sm">Register</h4>
          </ul>

          {/* Tabs Container */}
          <div className="tabs-container">
            {/* Tab 1: Register with Google */}
            <button
              // disabled
              className="flex items-center justify-center w-full px-4 py-3 bg-gray-100 rounded-lg shadow-md hover:bg-gray-200"
              onClick={() => loginWithGoogle()}
            >
              <TbBrandGoogle className="w-6 h-6 mr-2" />
              Register with Google
            </button>

            <div className="flex justify-center py-2">
              <h3 className="text-xs text-gray-500">OR</h3>
            </div>
            <div className="relative flex justify-center my-2">
              <div className="absolute inset-0 flex items-center justify-between">
                <div className="w-1/3 h-px bg-gray-300"></div>
                <div className="w-1/3 h-px bg-gray-300"></div>
              </div>
            </div>

            <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
              {/* Username Input */}
              <div>
                <label
                  htmlFor="user"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  Username - NOT EMAIL
                </label>
                <input
                  {...register("user")}
                  type="text"
                  id="user"
                  className={`custom-input_change ${
                    errors.user ? "error" : ""
                  } p-3 w-full border border-gray-200`}
                />
                {/* {errors.user && <p className="text-sm text-red-500">{errors.user.message}</p>} */}
              </div>

              {/* Email Input */}
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  Email
                </label>
                <input
                  {...register("email")}
                  type="email"
                  id="email"
                  className={`custom-input_change ${
                    errors.email ? "error" : ""
                  } p-3 w-full border border-gray-200`}
                />
                {/* {errors.email && <p className="text-sm text-red-500">{errors.email.message}</p>} */}
              </div>

              {/* Password Input */}
              <div className="relative">
                <label
                  htmlFor="password"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  Password
                </label>
                <input
                  {...register("password")}
                  type={showPassword ? "text" : "password"}
                  id="password"
                  className={`custom-input_change ${
                    errors.password ? "error" : ""
                  } p-3 w-full border border-gray-200 rounded-md`}
                />
                <span
                  onClick={togglePasswordVisibility}
                  className="absolute transform -translate-y-1/2 cursor-pointer right-3 top-1/2"
                >
                  {showPassword ? <FaEye /> : <FaEyeSlash />}
                </span>
                {/* {errors.password && (
                                    <p className="mt-1 text-sm text-red-500">{errors.password.message}</p>
                                )} */}
              </div>

              {/* Repeat Password Input */}
              <div className="relative">
                <label
                  htmlFor="repeat_password"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  Repeat Password
                </label>
                <input
                  {...register("repeat_password")}
                  type={showPassword1 ? "text" : "password"}
                  id="repeat_password"
                  className={`custom-input_change ${
                    errors.repeat_password ? "error" : ""
                  } p-3 w-full border border-gray-200 rounded-md`}
                />
                <span
                  onClick={togglePasswordVisibility1}
                  className="absolute transform -translate-y-1/2 cursor-pointer right-3 top-1/2"
                >
                  {showPassword1 ? <FaEye /> : <FaEyeSlash />}
                </span>
                {/* {errors.repeat_password && (
                                    <p className="mt-1 text-sm text-red-500">{errors.repeat_password.message}</p>
                                )} */}
              </div>

              {/* Terms & Conditions Checkbox */}
              <div className="flex items-center">
                <input
                  type="checkbox"
                  {...register("agree")}
                  className="text-indigo-600 transition duration-150 ease-in-out form-checkbox"
                />
                &nbsp;
                <label
                  htmlFor="agree"
                  className="ml-2 text-sm leading-5 text-gray-900 !m-0"
                >
                  I agree to the{" "}
                  <span className="text-red-600">
                    <Link to="/terms-of-service">Terms of Service</Link>
                  </span>
                </label>
              </div>

              <div className="flex items-center">
                <input
                  type="checkbox"
                  {...register("newsletter")}
                  className="text-indigo-600 transition duration-150 ease-in-out form-checkbox"
                />
                <label
                  htmlFor="newsletter"
                  className="ml-2 text-sm leading-5 text-gray-900 !m-0 !ms-1 "
                >
                  Subscribe to{" "}
                  <span className="text-red-600">
                    <Link to="/terms-of-service"> newsletter</Link>
                  </span>
                </label>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className={`${
                  !watch("agree")
                    ? "bg-gray-400 pointer-events-none"
                    : "bg-[#8EC639]"
                } text-white font-bold py-2 px-4 rounded w-full hover:bg-green-600`}
                disabled={isSubmitting || !watch("agree")}
              >
                {isSubmitting ? "Submitting..." : "Register"}
              </button>
            </form>

            {/* Login Link */}
            <p className="mt-4 text-center">
              Already have an account?{" "}
              <span
                className="text-red-600 cursor-pointer"
                onClick={() => {
                  setIsModalOpen(true);
                  setIsRegister(false);
                }}
              >
                Log In
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
